interface EventProps {
  path: string;
  location: string;
}

interface BreadcrumbItem {
  path: string;
  label: string;
}

interface BreadcrumbItemWithEvents extends BreadcrumbItem {
  eventProps: EventProps;
}

export const generateSitemapWithEvents = (
  breadcrumbList: BreadcrumbItem[]
): BreadcrumbItemWithEvents[] => {
  return breadcrumbList.map(({ path, label }) => ({
    path,
    label,
    eventProps: {
      location: 'breadcrumb',
      path,
    },
  }));
};
